
import { Component, Mixins, Emit } from "vue-property-decorator";
import Login from "@/mixins/Login";
import FormLogin from "@/components/form/FormLogin/FormLogin.vue";
import FormAlignmentLine from "@/components/form/FormAlignmentLine/FormAlignmentLine.vue";
import FormAlignmentMGHRWC from "@/components/form/FormAlignmentMGHRWC/FormAlignmentMGHRWC.vue";
import BlockLine from "@/components/form/BlockLine/BlockLine.vue";
import axios, { AxiosResponse, AxiosError } from "axios";
import { fetchBanners } from "@/services/userService";
import store from "@/store";
import VueRouter from "vue-router";

Component.registerHooks(["beforeRouteEnter"]);

// @ is an alias to /src
@Component({
  components: {
    FormLogin,
    FormAlignmentLine,
    FormAlignmentMGHRWC,
    BlockLine,
  },
})
export default class LoginJa extends Mixins(Login) {
  private banner: BannerData[] = [];
  private viewState = 0;
  private hasUnsavedChanges = true;

  get redirectPayload() {
    return String(store.state.temp.redirectPayload);
  }

  get ResultLineAuth() {
    return String(store.state.temp.resultLineAuth);
  }

  private async beforeRouteEnter(to: any, from: VueRouter, next: any) {
    let resBanner: BannerData[] = [];
    try {
      resBanner = await fetchBanners({ cat: "login-page" });
    } finally {
      next((vm: { banner: any }) => {
        vm.banner = resBanner;
      });
    }
  }

  @Emit()
  updateViewState(num: number) {
    this.viewState = num;
  }

  private initData() {
    // switch (store.state.temp.resultLineAuth) {
    //   case "errorCode":
    //     this.updateViewState(1.25);
    //     break;
    //   case "errorFriendship":
    //     this.updateViewState(1.5);
    //     break;
    //   case "NotLinkedToLine":
    //     this.updateViewState(1);
    //     break;
    //   default:
    //     this.updateViewState(0);
    //     break;
    // }
    this.updateViewState(0);
  }

  // ライフサイクルで監視セット
  async created() {
    this.initData();
  }

  private mounted() {
    fetchBanners({ cat: "login-page" }).then((res) => {
      this.banner = res;
    });
    store.commit("loaded", true);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.viewState === 1) {
      const answer = window.confirm(
        "変更が保存されていません。ページを離れますか？"
      );
      if (!answer) {
        store.commit("loaded", true);
        next(false); // 離脱をキャンセル
        return;
      }
    }
    if (store.state.temp.redirectPayload) {
      store.commit("temp/clearRedirectPayload");
    }
    if (store.state.temp.resultLineAuth) {
      store.commit("temp/clearResultLineAuth");
    }
    this.initData();
    next(); // 離脱許可
  }
}
